import { render, staticRenderFns } from "./UDSwitchTextFieldCell.vue?vue&type=template&id=37fc2de8&"
import script from "./UDSwitchTextFieldCell.vue?vue&type=script&lang=js&"
export * from "./UDSwitchTextFieldCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
